import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  datasetXY,
  backgroundColor,
  tooltip,
  discreteLegend,
  color,
  pivotIndicators,
  initPivot,
  datasetPivot,
  pivotAdapter,
  pivotDiscreteLegend,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotRowDimensions,
  pivotColumnDimensions,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
  verticalCrosshairRect,
  initRoseParallel,
  roseAnimation,
  radiusAxis,
  progressive,
  pivotColorLegend,
  colorAdapter,
  linearColor,
  colorLegend,
  roseStyle,
  colorRoseStyleFill,
  labelPie,
  pivotHideIndicatorName,
  pivotTitle,
  addRegionPadding,
  dimensionLinkage,
  fontFamilyTheme,
} from '../pipes'

const roseParallel: VChartSpecPipeline = [
  fontFamilyTheme,
  initRoseParallel,
  roseAnimation,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetXY,
  animationMorph,
  progressive,
  radiusAxis,
  colorRoseStyleFill(roseStyle),
  colorAdapter(discreteLegend, colorLegend),
  labelPie,
  tooltip({ titleEncoding: 'angle' }),
  verticalCrosshairRect,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
]

const pivotRoseParallel: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  pivotHideIndicatorName,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initRoseParallel,
    roseAnimation,
    addRegionPadding,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetXY,
    animationMorph,
    progressive,
    radiusAxis,
    verticalCrosshairRect,
    colorRoseStyleFill(roseStyle),
    labelPie,
    tooltip({ titleEncoding: 'angle' }),
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationAreaBand,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const roseParallelSpecPipeline = [pivotAdapter(roseParallel, pivotRoseParallel)]
